"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePickerPopover = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = require("../../../../Button");
const convert12To24HourFormat_1 = require("./helpers/convert12To24HourFormat");
const TimePickerPopover_styles_1 = require("./TimePickerPopover.styles");
const constants_1 = require("../../helpers/constants");
const TimeSelector_1 = require("../../../../helpers/components/TimeSelector/TimeSelector");
const StackView_1 = require("../../../../StackView");
const View_1 = require("../../../../View");
exports.TimePickerPopover = react_1.default.memo(function TimePickerPopover({ value, is12Hours, onSelect, texts, onMouseDown, onRequestClose }) {
    const initialDraftHours = (0, react_1.useMemo)(() => {
        if (value && is12Hours && value.hours > 12) {
            return value.hours - 12;
        }
        if (value && is12Hours && value.hours === 0) {
            return 12;
        }
        return value ? value.hours : null;
    }, [is12Hours, value]);
    const [draftHours, setDraftHours] = (0, react_1.useState)(initialDraftHours);
    const [draftMinutes, setDraftMinutes] = (0, react_1.useState)(value ? value.minutes : null);
    const [draftIsAmTimePeriod, setDraftIsAmTimePeriod] = (0, react_1.useState)(!(value && value.hours >= 12));
    const [errorState, setErrorState] = (0, react_1.useState)({
        hours: false,
        minutes: false
    });
    const onHoursChange = (0, react_1.useCallback)((hours) => {
        setDraftHours(hours);
        setErrorState(Object.assign(Object.assign({}, errorState), { hours: false }));
    }, [errorState]);
    const onMinutesChange = (0, react_1.useCallback)((minutes) => {
        setDraftMinutes(minutes);
        setErrorState(Object.assign(Object.assign({}, errorState), { minutes: false }));
    }, [errorState]);
    const onTimePeriodChange = (0, react_1.useCallback)((isAmTimePeriod) => {
        setDraftIsAmTimePeriod(isAmTimePeriod);
    }, []);
    const onApply = (0, react_1.useCallback)(() => {
        setErrorState({
            hours: draftHours === null,
            minutes: draftMinutes === null
        });
        if (onSelect && draftHours !== null && draftMinutes !== null) {
            onSelect({
                hours: is12Hours
                    ? (0, convert12To24HourFormat_1.convert12To24HourFormat)(draftHours, draftIsAmTimePeriod)
                    : draftHours,
                minutes: draftMinutes
            });
            onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose();
        }
    }, [draftHours, draftIsAmTimePeriod, draftMinutes, is12Hours, onRequestClose, onSelect]);
    return (react_1.default.createElement(TimePickerPopover_styles_1.StyledTimePickerPopover, { "data-selector-id": constants_1.timePickerDataSelectorId.timeSelector, className: "vm-TimePickerPopover" },
        react_1.default.createElement(TimeSelector_1.TimeSelector, { is12Hours: is12Hours, hours: draftHours, minutes: draftMinutes, isAmTimePeriod: draftIsAmTimePeriod, onHoursChange: onHoursChange, onMinutesChange: onMinutesChange, onPeriodChange: onTimePeriodChange, texts: texts, errorHours: errorState.hours, errorMinutes: errorState.minutes }),
        react_1.default.createElement(TimePickerPopover_styles_1.StyledTimePickerFooter, { indentTop: View_1.INDENT.xl, gap: StackView_1.STACK_GAP.m, distribution: StackView_1.STACK_DISTRIBUTION.end, align: StackView_1.STACK_ALIGN.center, spaceFill: View_1.SPACE_FILL.all, onMouseDown: onMouseDown },
            react_1.default.createElement(TimePickerPopover_styles_1.StyledTimePickerButton, { "data-selector-id": constants_1.timePickerDataSelectorId.applyControl, onClick: onApply, type: "submit" }, texts.apply),
            react_1.default.createElement(TimePickerPopover_styles_1.StyledTimePickerButton, { "data-selector-id": constants_1.timePickerDataSelectorId.cancelControl, ui: Button_1.BUTTON_VIEW.secondary, onClick: onRequestClose, type: "button" }, texts.cancel))));
});
//# sourceMappingURL=TimePickerPopover.js.map